module.exports = __webpack_public_path__ + "static/img/guide_step1_unselect.95bba8ba.svg";